module.exports = __webpack_public_path__ + "img/order-empty.49aa9069.png";